import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

export const ClientsSecondaryViewStore = GenericFieldFactory("CLIENTS_SECONDARY_VIEW", null);